<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });
const props = defineProps(['status']);
const emit = defineEmits(['click']);

const getStatusColor = (status) => {
    switch (status) {
        case 'FINISHED':
            return {
                severity: 'success',
                text: t('status.completed'),
                icon: 'pi pi-check',
            };
        case 'BLOCKED':
            return {
                severity: 'danger',
                text: t('status.blocked'),
                icon: 'pi pi-ban',
            };
        case 'IN_PROGRESS':
            return {
                severity: 'info',
                text: t('status.process'),
                icon: 'pi pi-spinner',
            };
        case 'WAITING':
            return {
                severity: 'warn',
                text: t('status.waiting'),
                icon: 'pi pi-info-circle',
            };
        case 'NOT_TAKEN':
            return {
                severity: 'secondary',
                text: t('status.notStarted'),
                icon: 'pi pi-exclamation-triangle',
            };
        case 'INVALID':
            return {
                severity: 'contrast',
                text: t('status.invalid'),
                icon: 'pi pi-times',
            };
        case 'CREATED':
            return {
                severity: 'contrast',
                text: t('status.created'),
                icon: 'pi pi-times',
                color: '#3e83d0',
            };
    }
};
</script>

<template>
    <Tag :icon="getStatusColor(status)?.icon" :severity="getStatusColor(status)?.severity"
        :value="getStatusColor(status)?.text" rounded :style="`background: ${getStatusColor(status)?.color}`"></Tag>
</template>
<style scoped>
.p-tag-success {
    @apply text-green-500 bg-green-500/20;
}
</style>
